export class BulkSetRestoreTemplateRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "templateId",
            "baseName": "templateId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return BulkSetRestoreTemplateRequest.attributeTypeMap;
    }
    constructor() {
    }
}
